export default {
  listOrganCodeFilter: ['VNINDEX', 'HNXIndex', 'UpcomIndex', 'VN30', 'HNX30'],

  listOrganCodeFilterProprietary: ['VNINDEX'],

  listFilterByOrganCode: {
    VNINDEX: { key: 'VNINDEX', name: 'HOSE' },
    HNXIndex: { key: 'HNXIndex', name: 'HNX' },
    UpcomIndex: { key: 'UpcomIndex', name: 'UPCOM' },
    VN30: { key: 'VN30', name: 'VN30' },
    HNX30: { key: 'HNX30', name: 'HNX30' },
  },

  foreignDropDown: ['VALUE', 'NET_VALUE'],
  foreignDropDownData: {
    NET_VALUE: { key: 'NET_VALUE', name: 'moneyFlowForeign.FOREIGN_NET' },
    VALUE: {
      key: 'VALUE',
      name: 'moneyFlowForeign.FOREIGN_VALUE',
    },
  },

  proprietaryDropDown: ['VALUE', 'NET_VALUE'],
  proprietaryDropDownData: {
    NET_VALUE: {
      key: 'NET_VALUE',
      name: 'moneyFlowProprietary.PROPRIETARY_NET',
    },
    VALUE: {
      key: 'VALUE',
      name: 'moneyFlowProprietary.PROPRIETARY_VALUE',
    },
  },
};
